import * as React from 'react';
import { ButtonOutline } from '@grandvisionhq/iris-ui';
import { useCancelAndReturnsModalContentSlot } from '../../../context/CancelAndReturnsModalContentContext.js';
import CancelAndReturnsModal from '../CancelAndReturns/CancelAndReturnsModal.js';
import OrderHeader from '../Header/OrderHeader.js';

const Order = ({ children , footer , labels , orderDate , orderNumber , shipmentStatus , orderStatus , paymentStatus , onReorder , isOrderWorkflowStatusEnabled , onOpenCancelReturnsModal , isCancelReturnsModalOpen , onCloseCancelReturnsModal , isPaid , isReturnsEnabled , shouldShowOrderDate ,  })=>{
    const { Slots  } = useCancelAndReturnsModalContentSlot();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OrderHeader, {
        orderDate: orderDate,
        orderNumber: orderNumber,
        shipmentStatus: shipmentStatus,
        orderStatus: orderStatus,
        paymentStatus: paymentStatus,
        isOrderWorkflowStatusEnabled: isOrderWorkflowStatusEnabled,
        onReorder: onReorder,
        className: "order__header",
        shouldShowOrderDate: shouldShowOrderDate
    }), children, /*#__PURE__*/ React.createElement("div", {
        className: "order__footer-returns-modal"
    }, isReturnsEnabled ? null : Slots.ModalContent && isPaid ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ButtonOutline, {
        className: "returns-modal-button",
        onPress: ()=>onOpenCancelReturnsModal()
    }, labels.cancelAndReturns), isCancelReturnsModalOpen && /*#__PURE__*/ React.createElement(CancelAndReturnsModal, {
        ModalContent: Slots.ModalContent,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal
    })) : null), footer && /*#__PURE__*/ React.createElement("div", {
        className: "order__footer"
    }, footer));
};

export { Order, Order as default };
//# sourceMappingURL=Order.js.map
